import { makeStyles } from "@mui/styles";

export const useStyles = makeStyles(() => ({
    ReserveTableWidget: {
        background: "#f5f6fa",
        padding: "17px",
        height: "100%",
        display: "flex",
        width: "35vw",
        flexDirection: "column",
    },
    SmallTablePlaceholderWrapper: {
        marginBottom: "20px",
    },
    BtnSearch: {
        fontWeight: "700",
        fontSize: "14px",
        lineHeight: "17px",
        textTransform: "uppercase",
        color: "#6E7187",
        display: "flex",
        alignItems: "center",
        width: "100%",
        border: "1px solid #6E7187",
        borderRadius: "8px",
        padding: "14px",
        cursor: "pointer",
        flex: 1,
        background: "#f5f6fa",
        "& .IconWrap": {
            width: "24px",
            height: "24px",
            background: "#6E7187",
            borderRadius: "4px",
            color: "#fff",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            fontSize: "20px",
            marginRight: "8px",
        },
    },
    Customers: {
        marginBottom: "12px",
        "& .Customers__Title": {
            fontStyle: "normal",
            fontWeight: "700",
            fontSize: "14px",
            lineHeight: "17px",
            textTransform: "uppercase",
            color: "#6E7187",
            marginBottom: "12px",
        },
        "& .Customers__List": {
            "&>div": {
                fontStyle: "normal",
                fontWeight: "600",
                fontSize: "14px",
                lineHeight: "17px",
                color: "#e14954",
                padding: "17px",
                background: "#FFFFFF",
                borderRadius: "8px",
                marginBottom: "8px",
                cursor: "pointer",
                transition: "0.2s all",
                display: "flex",
                justifyContent: "space-between",
                "&:hover": {
                    color: "#FFFFFF",
                    background: "#e14954",
                },
            },
            "& .subtext": {
                fontSize: "xx-small",
            },
            "& .selected": {
                color: "#FFFFFF",
                background: "#e14954",
            },
        },
    },
    Actions: {
        // marginTop:'auto'
    },
}));
